var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "81px",
    viewBox: "0 0 80 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000180451128 0.383157895 79.6156391 0.383157895 79.6156391 79.9999398 0.000180451128 79.9999398"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 80.2183459 79.6156391 80.2183459 79.6156391 0.601503759 0 0.601503759"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobil-\\u2013-Desktop",
    transform: "translate(-223.000000, -890.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(223.000000, 890.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.218346)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6158195,40.191218 C79.6158195,62.176782 61.7932632,79.9999398 39.8070977,79.9999398 C17.8227368,79.9999398 0.000180451128,62.176782 0.000180451128,40.191218 C0.000180451128,18.2056541 17.8227368,0.383097744 39.8070977,0.383097744 C61.7932632,0.383097744 79.6158195,18.2056541 79.6158195,40.191218",
    id: "Fill-1",
    fill: "#3A913F",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "25.9771429 49.7942857 46.1353383 49.7942857 46.1353383 24.2616541 25.9771429 24.2616541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "27.8111278 44.2165414 44.4180451 44.2165414 44.4180451 26.2442105 27.8111278 26.2442105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8303158,27.8249624 C40.6089624,27.8249624 43.6736241,31.1410526 43.6736241,35.2306767 C43.6736241,39.3190977 40.6089624,42.635188 36.8303158,42.635188 C34.4736241,42.635188 32.3954286,41.3449624 31.1641504,39.3816541 L32.8399398,38.0288722 C33.6868571,39.441203 35.1587368,40.3765414 36.8303158,40.3765414 C39.4564812,40.3765414 41.585203,38.0715789 41.585203,35.2306767 C41.585203,32.3885714 39.4564812,30.0842105 36.8303158,30.0842105 C34.7996391,30.0842105 33.0655038,31.4628571 32.384,33.4015038 L34.3082105,33.4015038 L31.3740752,37.9344361 L28.4405414,33.4015038 L30.1993383,33.4015038 C30.9518195,30.1960902 33.6351278,27.8249624 36.8303158,27.8249624",
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "37.1410526 31.8662857 38.1509774 34.0810226 40.4096241 34.4359098 38.7753383 36.1604211 39.1603008 38.5941053 37.1410526 37.4446316 35.121203 38.5941053 35.5067669 36.1604211 33.8718797 34.4359098 36.1299248 34.0810226"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "33.1392481 54.955188 53.2968421 54.955188 53.2968421 29.4225564 33.1392481 29.4225564"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#3A913F",
    mask: "url(#mask-4)",
    points: "34.9732331 49.3774436 51.5795489 49.3774436 51.5795489 31.4051128 34.9732331 31.4051128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9925414,32.9859248 C47.7705865,32.9859248 50.8352481,36.3026165 50.8352481,40.3916391 C50.8352481,44.4806617 47.7705865,47.7967519 43.9925414,47.7967519 C41.6358496,47.7967519 39.5570526,46.5059248 38.3263759,44.5426165 L40.0015639,43.1898346 C40.8490827,44.6027669 42.3203609,45.5375038 43.9925414,45.5375038 C46.6181053,45.5375038 48.7474286,43.2331429 48.7474286,40.3916391 C48.7474286,37.5495338 46.6181053,35.2451729 43.9925414,35.2451729 C41.9618647,35.2451729 40.2283308,36.6238195 39.5462256,38.5624662 L41.4704361,38.5624662 L38.5363008,43.0953985 L35.6027669,38.5624662 L37.3615639,38.5624662 C38.1134436,35.3576541 40.7973534,32.9859248 43.9925414,32.9859248",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "44.3032782 37.0272481 45.313203 39.2425865 47.5718496 39.5968722 45.9375639 41.3213835 46.3219248 43.7556692 44.3032782 42.605594 42.2834286 43.7556692 42.668391 41.3213835 41.0335038 39.5968722 43.2921504 39.2425865"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile2);
export default __webpack_public_path__ + "static/media/mobile-2.9b3481729726d9cc09d4a85da6efe6a9.svg";
export { ForwardRef as ReactComponent };